import { Action } from '@ngrx/store';
import { FilterItemInterface } from 'app/site-filters/models';

import { SiteFilterActionType } from '.';

export class CreateManagementSiteFilterItem implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.CreateManagementSiteFilterItem;

  constructor(public readonly payload?: { filterId: number, filterItem: FilterItemInterface }) { }
}

export class CreateManagementSiteFilterItemCompleted implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.CreateManagementSiteFilterItemCompleted;

  constructor(public readonly payload?: { filterId: number, filterItem: FilterItemInterface }) { }
}

export class CreateManagementSiteFilterItemFailed implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.CreateManagementSiteFilterItemFailed;

  constructor(public readonly payload?: { filterId: number, filterItem: FilterItemInterface }) { }
}
